import {createSlice} from "@reduxjs/toolkit";

export const corso_corsiStore = createSlice({
    name: 'corso_corsi',
    initialState: {
        corsi: {},
        corso: null,
        tipiCorso: [],
        isError: false,
        participantsToTheDate: []
    },
    reducers: {
        initCorsi(state) {
            state.corsi = [];
        },
        getCorsiSuccess(state, action) {
            state.corsi = action.payload;
            state.error = null;
        },
        getCorsiFail(state, action) {
            state.corsi = {};
            state.error = action.payload
        },
        initCorso(state) {
            state.corso = null;
            state.tipiCorso = [];
            state.isError = false;
            state.participantsToTheDate = [];
        },
        getCorsoSuccess(state, action) {
            state.corso = action.payload;
        },
        getCorsoFail(state, action) {
            state.isError = action.payload;
        },
        getInitCorsoFail(state, action) {
            state.isError = action.payload;
        },
        getParticipantsToTheDateSuccess(state, action) {
            state.participantsToTheDate = action.payload;
        },
        initParticipants(state) {
            state.participantsToTheDate = [];
        },
        getAllTipiCorsoSuccess(state, action) {
            state.tipiCorso = action.payload;
            //state.isError = false;
        },
        getAllTipiCorsoError(state, action) {
            //state.tipiCorso = [];
            state.isError = action.payload;
        },
        updateAllieviCorso(state, action) {
            const idx = state.corso.allievi.find(a => a.idAnagrafica === action.payload.idAnagrafica);
            state.corso.allievi.splice(idx, 1, action.payload);
        }
    }
});

export const corsoCorsiActions = corso_corsiStore.actions;
